import React from 'react';
import { Col, Row, Tooltip, OverlayTrigger, Container } from 'react-bootstrap';

import boardWebChat from '../../../assets/images/videoChatWithLogo.PNG';

const BoardOfDirectors = ({ isMobile }) => (
  <Col>
    <Row>
      <Col>
        <h3
          id="board-of-directors"
          tabIndex="-1"
          style={{
            textAlign: 'center',
          }}
        >
          BOARD of directors
        </h3>
        <p>
          Expertise and guidance from the Board of Directors helps steer CSIO towards exciting, innovative endeavors. We sincerely thank these industry leaders for their invaluable contributions to another successful year.
        </p>
      </Col>
    </Row>
    <Row>
      <ComputerScreen />
    </Row>
    {/* <Row>
        <Col>
          <ol className={width > 992 ? 'boardOfDirectorsLg boardOfDirectors' : width > 768 ? 'boardOfDirectorsMd boardOfDirectors' : 'boardOfDirectorsSm boardOfDirectors'} >
            <li>
              Cam Loeppky<span className="boardOfDirectorsDesc"> CSIO Chairman; The Wawanesa Mutual Insurance Company, Senior Vice President & Chief Information Officer</span>
            </li>
            <li>
              Steve Earle<span className="boardOfDirectorsDesc"> Bauld Insurance, President</span>
            </li>
            <li>
              Mathieu Brunet<span className="boardOfDirectorsDesc"> MP2B Assurance Inc., Vice President Sales & Specialised Insurance</span>
            </li>
            <li>
              Robyn Young<span className="boardOfDirectorsDesc"> Excel & Y, Lundgren & Young Insurance, President & Chief Executive Officer</span>
            </li>
            <li>
              Luc Tanguay<span className="boardOfDirectorsDesc"> Intact Insurance, Vice President - Operations & Planning - Commercial Lines</span>
            </li>
            <li>
              John Elliott<span className="boardOfDirectorsDesc"> RSA Canada, Senior Vice President & Chief Information Officer</span>
            </li>
            <li>
              Michael Loeters<span className="boardOfDirectorsDesc"> PROLINK, Senior Vice President, Commercial Insurance & Risk Management</span>
            </li>
            <li>
              Peter Braid<span className="boardOfDirectorsDesc"> Guest Member; Insurance Brokers Association of Canada, Chief Executive Officer</span>
            </li>
            <li>
              Elaine Basque<span className="boardOfDirectorsDesc"> Aviva Canada, Vice President, Platforms</span>
            </li>
            <li>
              Christopher Harness<span className="boardOfDirectorsDesc"> Northbridge Financial Corporation, Chief Information Officer</span>
            </li>
            <li>
              Sheldon Wasylenko<span className="boardOfDirectorsDesc"> CSIO Vice-Chair; Rayner Agencies Ltd., General Manager</span>
            </li>
            <li>
              Michael Lin<span className="boardOfDirectorsDesc"> Travelers Canada, Chief Information Officer</span>
            </li>
            <li>
              Catherine Smola<span className="boardOfDirectorsDesc"> CSIO President & Chief Executive Officer</span>
            </li>
          </ol>
        </Col>
      </Row> */}
  </Col >
)

export default BoardOfDirectors;

const TooltipTarget = ({ left, name, title, number }) => {
  let height = window.innerWidth * .0525;
  if (height > 92) height = 92;
  // const top = (window.innerWidth * 31) / window.innerWidth;
  return (
    <Col xs={3} style={{ padding: 0 }}>
      <OverlayTrigger
        placement="top"
        delay={{ show: 250, hide: 400 }}
        overlay={
          <Tooltip id="button-tooltip" style={{ marginBottom: 2 }}>
            <div style={{ backgroundColor: 'white', textAlign: 'center' }}>
              <div className="boardOfDirectorsLg" style={{
                color: '#004761',
                letterSpacing: .7,
                fontSize: 14,
                fontFamily: 'Raleway Regular',
                fontWeight: 'bold',
                width: '100%'
              }}
              >
                {`${name}`}
              </div>

              <div className="boardOfDirectorsDesc">{` ${title}`}</div>
            </div>
          </Tooltip>
        }
      >
        <div style={{
          // border: '1px solid red',
          zIndex: 3,
          width: '100%',
          height: '100%'
        }} />
      </OverlayTrigger>
    </Col>

  )
};

const ComputerScreen = () => (
  <Container fluid>
    <Row>
      <Col>
        <div
          style={{
            position: 'static',
            // border: '1px solid blue',
            width: '100%',
            height: 'auto',
          }}
        >
          <div style={{
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            paddingTop: '20.5%',
            paddingBottom: '21.2%',
            paddingLeft: '13.75%',
            paddingRight: '14.75%',
            // border: '2px solid red',
            zIndex: 4
          }}>
            <Container style={{
              // border: '1px solid purple',
              height: '100%',
              padding: 0
            }}>
              <Row
                noGutters
                style={{
                  height: '25%'
                }}>
                <TooltipTarget name="Catherine Smola" title="President & Chief Executive Officer, CSIO" />
                <TooltipTarget name="Joseph Carnevale" title="Vice President, Wholesale Broking Excess Underwriting" />
                <TooltipTarget name="Steve Earle" title="President, Bauld Insurance" />
                <TooltipTarget name="Aly Kanji" title="President & Chief Executive Officer, InsureLine Brokers Inc." />
              </Row>
              <Row
                noGutters
                style={{
                  height: '25%'
                }}>
                <TooltipTarget name="Mathieu Brunet" title="Vice President, Insurance Operations MP2B Assurance" />
                <TooltipTarget name="Peter Braid, GUEST MEMBER" title="Chief Executive Officer, Insurance Brokers Association of Canada" />
                <TooltipTarget name="Sheldon Wasylenko, VICE CHAIR" title="General Manager, Rayner Agencies Ltd." />
                <TooltipTarget name="Luc Tanguay" title="Deputy Senior Vice President, Commercial Lines, Intact Insurance" />
              </Row>
              <Row
                noGutters
                style={{
                  height: '25%'
                }}>
                <TooltipTarget name="Michael Lin" title="Chief Information Officer, Travelers Canada" />
                <TooltipTarget name="Christopher Harness" title="Chief Information Officer, Northbridge Financial Corporation" />
                <TooltipTarget name="Elaine Basque" title="Vice President, Platforms, Aviva Canada" />
                <TooltipTarget name="Tatjana Lalkovic" title="Senior Vice President & Chief Information Officer, Economical Insurance" />
              </Row>
              <Row
                noGutters
                style={{
                  height: '25%'
                }}>
                <TooltipTarget name="Cam Loeppky, CHAIRMAN" title="Senior Vice President & Chief Information Officer, The Wawanesa Mutual Insurance Company" />
                <Col xs={3} />
                <Col xs={3} />
                <Col xs={3} />
              </Row>
            </Container>
          </div>
          <img
            src={boardWebChat}
            style={{
              width: '100%',
              height: 'auto',
            }}
            aria-label="CSIO Board of Directors"
          />
        </div>
      </Col>
    </Row>
  </Container>
)
